/**
 * Laedt SVG-Markup vom Server und cacht es prozessweit.
 *
 * Hintergrund: Damit die zwei Farben (Hintergrund + Bildfarbe via currentColor)
 * per CSS gesteuert werden koennen, muss das SVG INLINE im DOM stehen
 * (ein ueber background-image: url() geladenes SVG ist ein isoliertes
 * Dokument und kann weder currentColor erben noch per Host-CSS umgefaerbt
 * werden). Mehrfach genutzte/erneut gerenderte Kacheln duerfen das gleiche
 * SVG aber nicht jedes Mal neu laden -> Cache pro URL.
 *
 * fetch ist projektweit ueber cross-fetch/polyfill verfuegbar (siehe Request.js),
 * laeuft also auch auf alten LG WebOS / Tizen.
 */

// Bewusst ein einfaches Objekt und KEINE Map (auch kein Object.create):
// babel-runtime ersetzt beides durch core-js-Module aus vendor.js. Die Prod-Loader (WGT 2.0.x/2.6.9)
// laden vendor.js ohne Cache-Buster - ein TV mit dem alten vendor.js im Cache
// kennt das Modul nicht, und das neue app.js bricht schon beim Laden ab.
// Pruefen: scripts/check-vendor-compat.js.
const cache = {}; // url -> Promise<string>
const has = (url) => Object.prototype.hasOwnProperty.call(cache, url);

/**
 * Bereinigt rohes SVG-Markup fuer das sichere Inlining:
 * - schneidet alles vor dem <svg>-Tag ab (XML-Deklaration, Kommentare)
 * - entfernt <script>-Bloecke
 * - entfernt feste width/height-Attribute und setzt 100% (Kachel skaliert
 *   das SVG ueber das viewBox-Verhaeltnis selbst, zentriert via
 *   preserveAspectRatio=xMidYMid meet als Default)
 * @param {string} text
 * @returns {string}
 */
function sanitize(text) {
  if (!text) {
    return '';
  }
  let svg = text;

  const start = svg.indexOf('<svg');
  if (start > 0) {
    svg = svg.slice(start);
  }

  svg = svg.replace(/<script[\s\S]*?<\/script>/gi, '');

  // width/height am Wurzel-<svg> entfernen (egal ob "" oder '') und auf 100% setzen
  svg = svg.replace(/<svg([^>]*)>/i, function (match, attrs) {
    const cleaned = attrs.replace(/\s(width|height)\s*=\s*("[^"]*"|'[^']*')/gi, '');
    return '<svg' + cleaned + ' width="100%" height="100%">';
  });

  return svg;
}

/**
 * Laedt das SVG unter url und liefert das bereinigte Inline-Markup.
 * Fehler werden geschluckt (leerer String) und nicht gecacht, damit ein
 * spaeterer Versuch erneut laden kann.
 * @param {string} url
 * @returns {Promise<string>}
 */
export function loadSvg(url) {
  if (!url) {
    return Promise.resolve('');
  }
  if (!has(url)) {
    const request = fetch(url)
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Bad response from server: ' + res.status);
        }
        return res.text();
      })
      .then(sanitize)
      .catch(function (err) {
        console.warn('loadSvg failed:', url, err);
        delete cache[url];
        return '';
      });
    cache[url] = request;
  }
  return cache[url];
}



// WEBPACK FOOTER //
// ./src/helpers/SvgCache.js